import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ReactComponent as Verified } from '$icons/uncolored/verified.svg';
import getUserType from '$utils/getUserType';
import { UserTypes } from '$types/UserTypes';

const SPKCandidateCardSkill = ({
  skill,
  index,
  containerRef,
  setOverflowIndex,
  isVerified,
  shouldHighlight = false,
}: {
  skill: string;
  index: number;
  containerRef: HTMLDivElement | null;
  setOverflowIndex: (index: number) => void;
  isVerified?: boolean;
  shouldHighlight?: boolean;
}) => {
  const { ref, entry } = useInView({
    root: containerRef as HTMLDivElement,
    triggerOnce: true,
  });
  const userType = getUserType();

  useEffect(() => {
    if (!entry?.intersectionRatio) return;

    if (entry.intersectionRatio < 1) {
      setOverflowIndex(index);
    }
  }, [entry?.intersectionRatio, index, setOverflowIndex]);

  return (
    <span
      ref={ref}
      className={`text-xs rounded border border-gray-300 p-1 text-nowrap flex flex-row gap-2 ${
        shouldHighlight &&
        userType === UserTypes.INTERNAL &&
        'bg-internal-main text-white'
      }`}
    >
      <span>{skill}</span>
      {isVerified && (
        <Verified
          className={`w-4 h-4 ${
            !shouldHighlight && userType === UserTypes.INTERNAL
              ? 'fill-internal-main'
              : 'fill-white'
          } ${userType === UserTypes.EMPLOYER && 'fill-employer-primary'}`}
        />
      )}
    </span>
  );
};

SPKCandidateCardSkill.defaultProps = {
  isVerified: false,
  shouldHighlight: false,
};

export default SPKCandidateCardSkill;
